// Parsing/format de valores do tema: cor solida (#RRGGBB) ou degrade
// linear-gradient(NNNdeg, #XXXXXX 0%, #YYYYYY 100%).

export const HEX_RE = /^#[0-9a-fA-F]{6}$/;

// Aceita variacoes de espaco mas exige 2 stops em 0% e 100%.
export const GRADIENT_RE =
  /^linear-gradient\(\s*(\d{1,3})deg\s*,\s*(#[0-9a-fA-F]{6})\s+0%\s*,\s*(#[0-9a-fA-F]{6})\s+100%\s*\)$/;

export interface DegradeParsed {
  angle: number;
  c1: string;
  c2: string;
}

export function parseGradient(valor: string): DegradeParsed | null {
  const m = GRADIENT_RE.exec(valor);
  if (!m) return null;
  return { angle: Number(m[1]), c1: m[2]!, c2: m[3]! };
}

export function formatGradient({ angle, c1, c2 }: DegradeParsed): string {
  return `linear-gradient(${angle}deg, ${c1} 0%, ${c2} 100%)`;
}

export function isHex(valor: string): boolean {
  return HEX_RE.test(valor);
}

export function isGradient(valor: string): boolean {
  return GRADIENT_RE.test(valor);
}

export function isValorTemaValido(valor: string): boolean {
  return isHex(valor) || isGradient(valor);
}

// Pra exibir num swatch pequeno: se for hex retorna a cor; se for gradient
// retorna a primeira cor (c1) como fallback pro <input type="color">.
export function corBaseDoValor(valor: string): string {
  if (isHex(valor)) return valor;
  const g = parseGradient(valor);
  if (g) return g.c1;
  return '#000000';
}
